import { render, staticRenderFns } from "./participationRecord.vue?vue&type=template&id=42054a25&scoped=true&"
import script from "./participationRecord.vue?vue&type=script&lang=js&"
export * from "./participationRecord.vue?vue&type=script&lang=js&"
import style0 from "./participationRecord.vue?vue&type=style&index=0&id=42054a25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42054a25",
  null
  
)

export default component.exports